const jsonCombineParametr = [
  {
    category: [55, 57, 53, 62],
    price: 900,
  },
  {
    category: [55, 57, 53, 63],
    price: 900,
  },
  {
    category: [55, 57, 53, 64],
    price: 900,
  },
  {
    category: [55, 57, 50, 62],
    price: 900,
  },
  {
    category: [55, 57, 50, 63],
    price: 900,
  },
  {
    category: [55, 57, 50, 64],
    price: 900,
  },
  {
    category: [55, 57, 51, 62],
    price: 900,
  },
  {
    category: [55, 57, 51, 63],
    price: 900,
  },
  {
    category: [55, 57, 51, 64],
    price: 900,
  },
  {
    category: [55, 57, 61, 62],
    price: 900,
  },
  {
    category: [55, 57, 61, 63],
    price: 900,
  },
  {
    category: [55, 57, 61, 64],
    price: 900,
  },
  {
    category: [55, 58, 53, 62],
    price: 900,
  },
  {
    category: [55, 58, 53, 63],
    price: 900,
  },
  {
    category: [55, 58, 53, 64],
    price: 900,
  },
  {
    category: [55, 58, 50, 62],
    price: 900,
  },
  {
    category: [55, 58, 50, 63],
    price: 900,
  },
  {
    category: [55, 58, 50, 64],
    price: 900,
  },
  {
    category: [55, 58, 51, 62],
    price: 900,
  },
  {
    category: [55, 58, 51, 63],
    price: 900,
  },
  {
    category: [55, 58, 51, 64],
    price: 900,
  },
  {
    category: [55, 58, 61, 62],
    price: 900,
  },
  {
    category: [55, 58, 61, 63],
    price: 900,
  },
  {
    category: [55, 58, 61, 64],
    price: 900,
  },
  {
    category: [55, 59, 53, 62],
    price: 900,
  },
  {
    category: [55, 59, 53, 63],
    price: 900,
  },
  {
    category: [55, 59, 53, 64],
    price: 900,
  },
  {
    category: [55, 59, 50, 62],
    price: 900,
  },
  {
    category: [55, 59, 50, 63],
    price: 900,
  },
  {
    category: [55, 59, 50, 64],
    price: 900,
  },
  {
    category: [55, 59, 51, 62],
    price: 900,
  },
  {
    category: [55, 59, 51, 63],
    price: 900,
  },
  {
    category: [55, 59, 51, 64],
    price: 900,
  },
  {
    category: [55, 59, 61, 62],
    price: 900,
  },
  {
    category: [55, 59, 61, 63],
    price: 900,
  },
  {
    category: [55, 59, 61, 64],
    price: 900,
  },
  {
    category: [55, 60, 53, 62],
    price: 900,
  },
  {
    category: [55, 60, 53, 63],
    price: 900,
  },
  {
    category: [55, 60, 53, 64],
    price: 900,
  },
  {
    category: [55, 60, 50, 62],
    price: 900,
  },
  {
    category: [55, 60, 50, 63],
    price: 900,
  },
  {
    category: [55, 60, 50, 64],
    price: 900,
  },
  {
    category: [55, 60, 51, 62],
    price: 900,
  },
  {
    category: [55, 60, 51, 63],
    price: 900,
  },
  {
    category: [55, 60, 51, 64],
    price: 900,
  },
  {
    category: [55, 60, 61, 62],
    price: 900,
  },
  {
    category: [55, 60, 61, 63],
    price: 900,
  },
  {
    category: [55, 60, 61, 64],
    price: 900,
  },
  {
    category: [56, 57, 53, 62],
    price: 900,
  },
  {
    category: [56, 57, 53, 63],
    price: 900,
  },
  {
    category: [56, 57, 53, 64],
    price: 900,
  },
  {
    category: [56, 57, 50, 62],
    price: 900,
  },
  {
    category: [56, 57, 50, 63],
    price: 900,
  },
  {
    category: [56, 57, 50, 64],
    price: 900,
  },
  {
    category: [56, 57, 51, 62],
    price: 0,
  },
  {
    category: [56, 57, 51, 63],
    price: 900,
  },
  {
    category: [56, 57, 51, 64],
    price: 900,
  },
  {
    category: [56, 57, 61, 62],
    price: 0,
  },
  {
    category: [56, 57, 61, 63],
    price: 900,
  },
  {
    category: [56, 57, 61, 64],
    price: 900,
  },
  {
    category: [56, 58, 53, 62],
    price: 900,
  },
  {
    category: [56, 58, 53, 63],
    price: 900,
  },
  {
    category: [56, 58, 53, 64],
    price: 900,
  },
  {
    category: [56, 58, 50, 62],
    price: 900,
  },
  {
    category: [56, 58, 50, 63],
    price: 900,
  },
  {
    category: [56, 58, 50, 64],
    price: 0,
  },
  {
    category: [56, 58, 51, 62],
    price: 900,
  },
  {
    category: [56, 58, 51, 63],
    price: 900,
  },
  {
    category: [56, 58, 51, 64],
    price: 900,
  },
  {
    category: [56, 58, 61, 62],
    price: 900,
  },
  {
    category: [56, 58, 61, 63],
    price: 900,
  },
  {
    category: [56, 58, 61, 64],
    price: 900,
  },
  {
    category: [56, 59, 53, 62],
    price: 900,
  },
  {
    category: [56, 59, 53, 63],
    price: 900,
  },
  {
    category: [56, 59, 53, 64],
    price: 900,
  },
  {
    category: [56, 59, 50, 62],
    price: 900,
  },
  {
    category: [56, 59, 50, 63],
    price: 900,
  },
  {
    category: [56, 59, 50, 64],
    price: 900,
  },
  {
    category: [56, 59, 51, 62],
    price: 900,
  },
  {
    category: [56, 59, 51, 63],
    price: 900,
  },
  {
    category: [56, 59, 51, 64],
    price: 900,
  },
  {
    category: [56, 59, 61, 62],
    price: 900,
  },
  {
    category: [56, 59, 61, 63],
    price: 900,
  },
  {
    category: [56, 59, 61, 64],
    price: 900,
  },
  {
    category: [56, 60, 53, 62],
    price: 900,
  },
  {
    category: [56, 60, 53, 63],
    price: 900,
  },
  {
    category: [56, 60, 53, 64],
    price: 900,
  },
  {
    category: [56, 60, 50, 62],
    price: 900,
  },
  {
    category: [56, 60, 50, 63],
    price: 900,
  },
  {
    category: [56, 60, 50, 64],
    price: 900,
  },
  {
    category: [56, 60, 51, 62],
    price: 900,
  },
  {
    category: [56, 60, 51, 63],
    price: 900,
  },
  {
    category: [56, 60, 51, 64],
    price: 900,
  },
  {
    category: [56, 60, 61, 62],
    price: 900,
  },
  {
    category: [56, 60, 61, 63],
    price: 900,
  },
  {
    category: [56, 60, 61, 64],
    price: 900,
  },
];

const diff = (a1, a2) => {
  return a2.filter((i) => !a1.includes(i));
};

export const checkProductCategory = () => {
  if (window.jsonCombineParametr && window.jsonCombineParametr.length) {
    const notPriceElements = window.jsonCombineParametr.filter((element) => element.price === 0);

    if (notPriceElements.length) {
      const formElement = document.querySelector(`.js-get-category`);
      const inputsElements = document.querySelectorAll(`.js-select-h-input`);

      let hiddenElements = [];

      formElement.addEventListener(`click`, (evt) => {
        if (evt.target.classList.contains(`js-select-item`)) {
          if (hiddenElements.length) {
            hiddenElements.forEach((element) => element.classList.remove(`hide`));
            hiddenElements = [];
          }
          const parameters = [];
          inputsElements.forEach((el) => parameters.push(+el.value));

          const differents = [];
          notPriceElements.forEach((element) => {
            const diffParameters = diff(parameters, element.category);

            if (diffParameters.length === 1) {
              differents.push(diffParameters[0]);
            }
          });

          differents.forEach((value) => {
            const hiddenElement = formElement.querySelector(`[data-value="${value}"]`);
            hiddenElement.classList.add(`hide`);
            hiddenElements.push(hiddenElement);
          });
        }
      });
    }
  }
};
